var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCartWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "shopping_cart-24px",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M8.2,21.2a2.4,2.4,0,1,0,2.4,2.4A2.4,2.4,0,0,0,8.2,21.2ZM1,2V4.4H3.4l4.32,9.108L6.1,16.448A2.32,2.32,0,0,0,5.8,17.6,2.407,2.407,0,0,0,8.2,20H22.6V17.6H8.7a.3.3,0,0,1-.3-.3l.036-.144L9.52,15.2h8.94a2.389,2.389,0,0,0,2.1-1.236l4.3-7.788A1.172,1.172,0,0,0,25,5.6a1.2,1.2,0,0,0-1.2-1.2H6.052L4.924,2H1ZM20.2,21.2a2.4,2.4,0,1,0,2.4,2.4A2.4,2.4,0,0,0,20.2,21.2Z",
    transform: "translate(-1 -2)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCartWhite);
export default __webpack_public_path__ + "static/media/icon_cart_white.a05b789b7de8c6d3601eebdfc1215a12.svg";
export { ForwardRef as ReactComponent };